var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"target"},[_vm._t("default",null,{"droppable":_vm.droppable,"activeDrop":_vm.activeDrop})],2)}
var staticRenderFns = []

export { render, staticRenderFns }